// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      .button-container {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
      }

      .search-form {
        margin-bottom: 20px;
      }

      .search-input {
        width: 100%;
      }
    `, "",{"version":3,"sources":["webpack://./projects/ert/src/app/ert-preplan-rescue/ert-preplan-rescue.component.ts"],"names":[],"mappings":";MACM;QACE,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;MACrB;;MAEA;QACE,mBAAmB;MACrB;;MAEA;QACE,WAAW;MACb","sourcesContent":["\n      .button-container {\n        display: flex;\n        justify-content: space-between;\n        margin-bottom: 10px;\n      }\n\n      .search-form {\n        margin-bottom: 20px;\n      }\n\n      .search-input {\n        width: 100%;\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
